import React, { useState } from 'react'
import { observer } from 'mobx-react'
import swal from 'sweetalert'
import { NavLink } from 'react-router-dom'
import { localisationMaster } from 'Localisation/Localisation'
import { dateFormat } from 'helpers/date'
import Stores from 'Stores'
import groupStore from 'Stores/groupStore'
import modalStore from 'Stores/modalStore'
import LocalStorage from 'services/LocalStorage'
import st from './TeacherCard.module.scss'
import Avatar from '../../../../../../HeadBox/components/Avatar/Avatar'
import { EditIconButton } from 'components/UI/SuperButton/SuperButton'

function TeacherCard({ teacher }) {
  const { isTeacher } = Stores
  const {
    group: {
      group: {
        new_schedule: isNewSchedule,
        online: isOnline,
        default_price: {
          hours_type: { minutes },
        },
        ...group
      },
      students,
    },
  } = groupStore
  const selfUserID = LocalStorage.get('ud').user_data.id
  // Тип часов в группе
  const hoursType = minutes === 45 ? 'academ_hour' : 'astro_hour'
  // Количество актуальных студентов
  const actualStudentsCount = students.filter((st) => st.status === 1).length

  const [isShow, setIsShow] = useState(false)

  const salaryRange = (salary_hours_type, key) => {
    return salary_hours_type
      ? salary_hours_type[hoursType][key][actualStudentsCount] + ',00  тг.'
      : localisationMaster('not_set', 'groups/group')
  }

  const showTooltip = () => {
    setIsShow(true)
  }

  const openModalSalary = () => {
    const { id, full_name, salary_hours_type, teacher_salary_id } = teacher
    const ms = {
      link:
        'ledger/teacher_group_salary' +
        (salary_hours_type ? '/' + teacher_salary_id : ''),
      button: localisationMaster('text_54', 'groups/all-groups'),
      title:
        Stores.transliterate(full_name) +
        ' : ' +
        localisationMaster('text_4', 'reports/teacher-statistics'),
      type: 'teacher_salary',
      data: 'json',
      is_put: !!salary_hours_type,
      valid: {
        salary_hours_type: 'required',
        date_from: 'required',
      },
      func: (data) => {
        const teacher = data.find((x) => x.id === id)
        swal(
          `${localisationMaster('text_5', 'groups/group', 'modal')}`,
          `${localisationMaster('rate', 'groups/group')} "${teacher.salary_hours_type.name}" ${localisationMaster('text_6', 'groups/group', 'modal')} ${teacher.full_name} ${localisationMaster('text_7', 'groups/group', 'modal')} ${dateFormat(new Date(teacher.salary_hours_type.date_from))}`,
          'success',
        )
        groupStore.updateGroupData({ teachers: data })
      },
    }
    const md = {
      group: group.id,
      teacher: id,
      ...(salary_hours_type && {
        salary_hours_type: salary_hours_type.id,
        date_until: salary_hours_type.date_until,
        date_from: salary_hours_type.date_from,
      }),
    }
    modalStore.activity(ms, md)
  }

  return (
    <div
      onMouseEnter={() => showTooltip()}
      onMouseLeave={() => setIsShow(false)}
      className={st.container}
    >
      <div className={st.card}>
        <div className={st.avatar}>
          {
            teacher.avatar ? (
              <img
                src={Stores.baseLink() + teacher.avatar}
                alt={teacher.first_name}
              />
            ) : (
              <Avatar
                first_name={teacher.first_name}
                last_name={teacher.last_name}
              />
            )
            // <AvatairCreator squad name={teacher.last_name} l_name={teacher.first_name}/>
          }
        </div>
        <div className={st.info}>
          <span>
            <NavLink to={'/account/' + teacher.user_id}>
              {Stores.transliterate(
                teacher.last_name + ' ' + teacher.first_name,
              )}
            </NavLink>
          </span>
          {(!isTeacher || selfUserID === teacher.user_id) && (
            <ul>
              <li>
                {localisationMaster('hours_total', 'groups/group')}:&nbsp;
                <b>
                  {teacher.minutes > 0 && teacher.salary
                    ? (
                        teacher.minutes /
                        (teacher.salary.hours_type === 1 ? 45 : 60)
                      ).toFixed(2)
                    : 0}
                  {teacher.salary && teacher.salary.hours_type === 1
                    ? localisationMaster('ac_h', 'groups/group')
                    : localisationMaster('astr_h', 'groups/group')}
                </b>
              </li>
              <li>
                {localisationMaster('payment', 'groups/group')}:&nbsp;
                <b>
                  {Stores.cleanSumm(teacher.earned_salary / 100)}{' '}
                  {localisationMaster('tg', 'groups/group')}.
                </b>
              </li>
              <li>
                {localisationMaster('rate', 'groups/group')}:&nbsp;
                <b>
                  {salaryRange(
                    teacher.salary,
                    isOnline ? 'rate_online' : 'rate',
                  )}
                </b>
              </li>
            </ul>
          )}
        </div>

        {isShow && (!isTeacher || selfUserID === teacher.user_id) && (
          <div className={st.additionalInfo}>
            <div className={st.additionalInfo__block}>
              <b>{`${localisationMaster('text_2', 'reports/teacher-statistics')}: ${Stores.cleanSumm(teacher.earned_salary / 100)} тг. за ${teacher.minutes > 0 && teacher.salary ? (teacher.minutes / (teacher.salary.hours_type === 1 ? 45 : 60)).toFixed(2) : 0} ${teacher.salary && teacher.salary.hours_type === 1 ? localisationMaster('ac_h', 'groups/group') : localisationMaster('astr_h', 'groups/group')}`}</b>
              {teacher.salary && (
                <ul>
                  <li>{teacher.salary.name}</li>
                  <li>
                    {localisationMaster('online', 'groups/group')}:{' '}
                    <b>{salaryRange(teacher.salary, 'rate_online')}</b>
                  </li>
                  <li>
                    {localisationMaster('offline', 'groups/group')}:{' '}
                    <b>{salaryRange(teacher.salary, 'rate')}</b>
                  </li>
                  <li>
                    {localisationMaster('text_17', 'groups/group', 'student')}:{' '}
                    <b>{dateFormat(new Date(teacher.salary.date_from))}</b> г.
                  </li>
                </ul>
              )}
            </div>
            {!isTeacher && <EditIconButton onClick={openModalSalary} />}
          </div>
        )}
      </div>
    </div>
  )
}

export default observer(TeacherCard)
